import React from 'react';
import {graphql} from 'gatsby';
import {Box} from '@mui/material';
import {useTranslation} from 'gatsby-plugin-react-i18next';

import SEO from '../../../components/Seo';
import {getAllPdf} from '../../../services/utils';
import useSelectedArea from '../../../hooks/use-selected-area';
import ourCaramelData from '../../../assets/data/ourCaramel.json';
import SelectArea from '../../../components/Shared/SelectArea/SelectArea';
import ProductCategory from '../../../components/Documentation/ProductCategory';
import type {PageHeadProps} from '../../../types/page';
import type {I18nTranslations} from '../../../types/i18next';


const ProductDocumentation = () => {
  const {t} = useTranslation();
  const allPdf = getAllPdf('all');
  const [selectedArea, setSelectedArea] = useSelectedArea();

  return (
    <Box pt="3rem">
      <SelectArea selectedArea={selectedArea} setSelectedArea={setSelectedArea}/>

      <ProductCategory
        category={1}
        allPdf={allPdf}
        selectedArea={selectedArea}
        data={ourCaramelData['caramel-color']}
        title={t('caramel-color.classI.title')}
      />
      <ProductCategory
        category={2}
        allPdf={allPdf}
        selectedArea={selectedArea}
        data={ourCaramelData['caramel-color']}
        title={t('caramel-color.classII.title')}
      />
      <ProductCategory
        category={3}
        allPdf={allPdf}
        selectedArea={selectedArea}
        data={ourCaramelData['caramel-color']}
        title={t('caramel-color.classIII.title')}
      />
      <ProductCategory
        category={4}
        allPdf={allPdf}
        selectedArea={selectedArea}
        data={ourCaramelData['caramel-color']}
        title={t('caramel-color.classIV.title')}
      />

      <ProductCategory
        category={1}
        allPdf={allPdf}
        selectedArea={selectedArea}
        data={ourCaramelData['caramelized-sugar-syrups-burnt-sugar']}
      />
      <ProductCategory
        category={2}
        allPdf={allPdf}
        selectedArea={selectedArea}
        data={ourCaramelData['caramelized-sugar-syrups-burnt-sugar']}
      />

      <ProductCategory
        category={1}
        allPdf={allPdf}
        selectedArea={selectedArea}
        data={ourCaramelData['caramel-ingredients']}
      />
      <ProductCategory
        category={2}
        allPdf={allPdf}
        selectedArea={selectedArea}
        data={ourCaramelData['caramel-ingredients']}
      />
    </Box>
  );
};


export default ProductDocumentation;


export const Head = ({data}: PageHeadProps) => {
  const translations: I18nTranslations = JSON.parse(data.locales.edges[0].node.data);

  return (
    <SEO
      title={`${translations.documentation.product_doc.name} | ${translations.sethness_roquette}`}
      description={translations.documentation.product_doc.name}
    />
  );
};


export const query = graphql`
  query($language: String!, $defaultLang: String!) {
    locales: allLocale(filter: {language: {in: [$language, $defaultLang]}}) {
      ...I18nFragment
    },
  }
`;
